<div class="qbot-tour-banner">
  <div class="qbot-tour-greeting">
    <h1>Hi!</h1>
    <h2 class="user-name text-primary">{{settings.user['displayName']}}</h2>
  </div>
</div>

<div class="qbot-tour-content text-center">
  <h1>
    Welcome to QNE AI Cloud Accounting!
  </h1>
  <p>
    I am <b>QBot</b>, I'm thrilled to have you on board! Let's help you familiarize the system and experience all the
    incredible features
    <span *ngIf="settings.user['company']['isFreeTrial']">that come with your <b>30-day Free Trial!</b></span>
    <span *ngIf="!settings.user['company']['isFreeTrial']">. To begin, click the button below.</span>
  </p>

  <button type="button" nz-button nzSize="large" nzType="primary" (click)="startTour()" nzShape="round">Take a tour with me!</button>
</div>


<!-- <img src="./assets/img/qtob_tour.jpg" /> -->